import { EditorNodeName } from "@/enums/customAttributes";

import type { EditorNode } from "@/models/TextEditor";

export const isWhitespaceNode = (node: EditorNode): boolean =>
  node.type === EditorNodeName.whitespace;

const INDENT_SIZE = 4;

const createWhitespaceNode = (content: string): EditorNode => ({
  id: crypto.randomUUID(),
  type: EditorNodeName.whitespace,
  content,
  atomic: false,
  isOperand: false,
  isOperator: false,
  error: {},
});

const getIndent = (depth: number): string => " ".repeat(depth * INDENT_SIZE);

export const formatFormula = (tokens: EditorNode[]): EditorNode[] => {
  if (!tokens.length) {
    return [];
  }

  const result: EditorNode[] = [];
  let depth = 0;

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];

    if (isWhitespaceNode(token)) {
      continue;
    }

    if (token.type === EditorNodeName.parenthesis && token.content === ")") {
      depth = Math.max(0, depth - 1);
      result.push(createWhitespaceNode(`\n${getIndent(depth)}`));
    }

    result.push({ ...token });

    if (token.type === EditorNodeName.parenthesis && token.content === "(") {
      depth++;
      result.push(createWhitespaceNode(`\n${getIndent(depth)}`));
    }

    if (token.type === EditorNodeName.separator && token.content === ",") {
      result.push(createWhitespaceNode(`\n${getIndent(depth)}`));
    }
  }

  return result;
};

export const compactFormula = (tokens: EditorNode[]): EditorNode[] => {
  if (!tokens.length) {
    return [];
  }

  return tokens.filter((token) => !isWhitespaceNode(token));
};

export const hasWhitespaceFormatting = (tokens: EditorNode[]): boolean => {
  return tokens.some(
    (token) => isWhitespaceNode(token) && token.content?.includes("\n")
  );
};
